import { render, staticRenderFns } from "./lessonDetail3.vue?vue&type=template&id=2d4ecfc1&scoped=true&"
import script from "./lessonDetail3.vue?vue&type=script&lang=js&"
export * from "./lessonDetail3.vue?vue&type=script&lang=js&"
import style0 from "./lessonDetail3.vue?vue&type=style&index=0&id=2d4ecfc1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ecfc1",
  null
  
)

export default component.exports